/**
 * @file TaskDetailHeader.jsx
 * @location src/components/modals/progmodal/TaskDetailHeader.jsx
 * @role 업무 상세 모달 3모드 공통 정보 헤더 — 상태·기한·긴급도·담당/지시·설명
 *
 * editable=true 일 때 TaskDetailHeaderEdit 에 위임 (매니저 인라인 편집).
 */
import { useState } from 'react';
import { useApp } from '../../../store/AppContext';
import { useMembers } from '../../../store/useMembers';
import { ackStatusMeta, priorityMeta, isOverdue } from '../../../data/constants';
import { fmtShort } from '../../../utils/dateUtils';
import { refLabel } from '../../../utils/refs.js';
import { Icon } from '../../ui/Icon';
import { TaskDetailHeaderEdit } from './TaskDetailHeaderEdit';

/**
 * @param {{ task: import('../../../data/types.js').Task, editable?: boolean }} props
 */
export function TaskDetailHeader({ task, editable }) {
  const { S } = useApp();
  const { mname } = useMembers();
  const [editMode, setEditMode] = useState(false);
  // 지시자가 보는 본인(예: 검수자=지시자) → 「← 본인」 표기는 정보량이 적어 생략
  const selfInstructed = task.aor === S.uid;

  if (editable && editMode) {
    return (
      <div className="td-head-wrap">
        <TaskDetailHeaderEdit task={task} />
        <div className="td-edit-bar">
          <button className="btns" onClick={() => setEditMode(false)}><Icon name="check" size={13} /> 편집 종료</button>
        </div>
      </div>
    );
  }

  const sm = ackStatusMeta(task.status, task.acknowledgedAt);
  const od = isOverdue(task.due, task.status);
  const pm = priorityMeta(task.priority);
  return (
    <div className="td-head">
      <div className="td-title-row">
        <span className="td-title">{task.title}</span>
        <span className={`tag ${pm.cls}`}>{pm.label}</span>
        {editable && (
          <button className="td-edit-btn" onClick={() => setEditMode(true)} title="편집">
            <Icon name="edit" size={13} /> 편집
          </button>
        )}
      </div>
      <div className="td-info">
        <div className="td-row"><span className="td-k">상태</span><span className="td-v"><span className={`tag ${sm.cls}`}>{sm.label}</span></span></div>
        <div className="td-row"><span className="td-k">{task.dateKind === 'ondate' ? '지정일' : '기한'}</span><span className="td-v">{task.due ? fmtShort(task.due) : '—'}{task.dateKind === 'ondate' && <span className="due-tag ondate" style={{ marginLeft: 4 }}>당일</span>}{od && <span className="td-over"> 초과</span>}</span></div>
        <div className="td-row"><span className="td-k">{selfInstructed ? '담당' : '담당 / 지시'}</span><span className="td-v">{mname(task.aee)}{!selfInstructed && <span className="td-sub"> ← {mname(task.aor)}</span>}</span></div>
        {task.note?.trim() && <div className="td-row"><span className="td-k">설명</span><span className="td-v td-note">{task.note}</span></div>}
        {task.refs?.length > 0 && (
          <div className="td-row"><span className="td-k">참고</span><span className="td-v td-refs">
            {task.refs.map((r, i) => (
              <a key={`${r.url}-${i}`} className="td-ref" href={r.url} target="_blank" rel="noopener noreferrer">
                <Icon name="link" size={11} /> {refLabel(r)}
              </a>
            ))}
          </span></div>
        )}
      </div>
    </div>
  );
}
